/**
 * Web Input Component
 *
 */

import Password from '../../extensions/forms/Field/Password'

/**
 * @deprecated in v11, use `Field.Password instead.`
 */
const InputPassword = Password

export default InputPassword

InputPassword._formElement = true
InputPassword._supportsSpacingProps = true
